import updateOptionsWithValue from "./updateOptionsWithValue";

const setOptionHandler =
  (handlerName) => (props) => (optionId, optionValue) => {
    props[handlerName](updateOptionsWithValue(optionId, optionValue));
  };

export default setOptionHandler;
